import React from 'react';
import { Canvas } from '@react-three/fiber';
import { OrbitControls } from '@react-three/drei';
import GLBPreview from './GLBPreview.js';

const ItemPreview = ({ selectedStore, items, selectedItem }) => (
  <div style={{ flex: '1' }}>
    <div style={{ display: 'flex', gap: '20px' }}>
      <div style={{ flex: '1' }}>
        {selectedItem ? (
          <div>
            <div
              style={{
                height: '400px',
                backgroundColor: '#F5F5F5',
                borderRadius: '8px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Canvas key={selectedItem.id} style={{ width: '100%', height: '100%' }}>
                <ambientLight intensity={0.5} />
                <directionalLight position={[5, 5, 5]} intensity={1} />
                <GLBPreview url={selectedItem.glbUrl} />
                <OrbitControls enableZoom={false} enablePan={false} rotateSpeed={0.5} />
              </Canvas>
            </div>
          </div>
        ) : (
          <div
            style={{
              height: '400px',
              backgroundColor: '#F5F5F5',
              borderRadius: '8px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <p style={{ color: '#666', fontSize: '14px' }}>
              Select an item to preview
            </p>
          </div>
        )}
      </div>
    </div>
  </div>
);

export default ItemPreview;